import * as addProductImage from 'store/actions/products/images/addImage';
import * as deleteProductImage from 'store/actions/products/images/deleteImage';
import * as fetchProductImages from 'store/actions/products/images/fetchImages';
import * as setHighlightedProductImage from 'store/actions/products/images/setHighlightedProductImage';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import * as types from 'store/actions/types';
import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';

function* fetchProductImagesAsync({ payload }) {
    try {
        const params = Object.assign({
            includes: [
                'images',
                'imageVersions',
            ],
        }, {});

        const url = `${ config.getApiBaseUrl() }/products/${ payload.id }/images`;

        const response = yield apiClient.read(url, params);

        yield put(fetchProductImages.fetchProductImagesSuccess(payload, response));
    } catch (error) {
        yield put(fetchProductImages.fetchProductImagesFailure(error));
    }
}

function* addProductImageAsync({ payload }) {
    const { id, formData } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/products/${ id }/images?includes[]=images&includes[]=imageVersions`;

        const response = yield apiClient.createFile(url, formData);

        yield put(addProductImage.addProductImageSuccess(id, response));
    } catch (error) {
        yield put(addProductImage.addProductImageFailure(error));
    }
}

function* addProductImageSuccessAsync() {
    yield put(showNotification('notifications.products.images.create.success'));
}

function* addProductImageFailureAsync({ error }) {
    yield put(showNotification(error.response.message, 'warning'));
}

function* failureMessage({ error }) {
    const { message } = error.response;

    if (!message) {
        return;
    }

    yield put(showNotification(message, 'warning'));
}

function* deleteProductImageAsync({ payload }) {
    const { id, image_id, product_id } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/products/${ product_id }/images/${ id }`;

        yield apiClient.delete(url);

        yield put(deleteProductImage.deleteProductImageSuccess(product_id, image_id));
    } catch (error) {
        yield put(deleteProductImage.deleteProductImageFailure(error));
    }
}

function* deleteProductImageSuccessAsync() {
    yield put(showNotification('notifications.products.images.delete.success'));
}

function* setHighlightedProductImageAsync({ payload }) {
    const { id, product_id, is_highlighted } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/products/${ product_id }/images/${ id }`;
        const response = yield apiClient.patch(url, { is_highlighted });

        yield put(setHighlightedProductImage.setHighlightedProductImageSuccess(product_id, response));
    } catch (error) {
        yield put(setHighlightedProductImage.setHighlightedProductImageFailure(error));
    }
}

export default function* productImagesSagas() {
    yield [
        takeEvery(types.FETCH_PRODUCT_IMAGES, fetchProductImagesAsync),
        takeEvery(types.FETCH_PRODUCT_IMAGES_FAILURE, failureMessage),

        takeEvery(types.ADD_PRODUCT_IMAGE, addProductImageAsync),
        takeEvery(types.ADD_PRODUCT_IMAGE_FAILURE, addProductImageFailureAsync),
        takeEvery(types.ADD_PRODUCT_IMAGE_SUCCESS, addProductImageSuccessAsync),

        takeEvery(types.DELETE_PRODUCT_IMAGE, deleteProductImageAsync),
        takeEvery(types.DELETE_PRODUCT_IMAGE_FAILURE, failureMessage),
        takeEvery(types.DELETE_PRODUCT_IMAGE_SUCCESS, deleteProductImageSuccessAsync),

        takeEvery(types.SET_HIGHLIGHTED_PRODUCT_IMAGE, setHighlightedProductImageAsync),
        takeEvery(types.SET_HIGHLIGHTED_PRODUCT_IMAGE_FAILURE, failureMessage),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/product/productImagesSagas.js